// Page.js
import React, { useState, useEffect } from "react";
import { checkForUpdates } from "../utils/jsonUtils";

const Page = ({ pageKey }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    checkForUpdates(pageKey, setContent);
  }, [pageKey]);

  if (!content) return <div>Chargement...</div>;

  return (
    <div>
      <h1>{content.title}</h1>
      {content.elements.map((element) =>
        element.type === "text" ? (
          <div
            key={element.id}
            dangerouslySetInnerHTML={{ __html: element.content }}
          />
        ) : (
          <img key={element.id} src={element.content} alt="" />
        )
      )}
    </div>
  );
};

export default Page;
